<script setup>
import { computed } from 'vue'

const emit = defineEmits(['open'])
const props = defineProps(['model'])
const recipients = computed(() =>
  props.model.email_addresses
    .map(emailobj => (emailobj.name ? `${emailobj.name} <${emailobj.email}>` : emailobj.email))
    .join(', ')
)

const haveUploads = computed(() => {
  return props.model?.uploads?.length > 0 || props.model?.official_reply?.uploads?.length > 0
})

function clickCatch({ target }) {
  if (target.classList.contains('dload-link')) {
    return
  }
  emit('open', props.model)
}
</script>
<template>
  <div class="card" @click="clickCatch">
    <div class="card-body p-2">
      <div class="d-flex">
        <div>{{ model.date_start }}</div>
        <div>
          <span class="me-2">{{ model.date_created }}</span>
          <span class="me-2">{{
            model?.author?.fio || model?.author?.username || model?.sender_email
          }}</span>
          <span class="me-2 text-danger" v-if="model.repeat_mess">Повторное</span>
          <span class="me-2 text-success" v-if="model?.channel?.key === 'email' && model?.sent"
            >Отправлено</span
          >
          <span
            class="me-2 text-danger"
            v-if="model?.channel?.key === 'email' && !model?.sent && !model?.sender_email"
            >Не отправлено!</span
          >
        </div>
        <div class="ms-auto">{{ model.channel?.value }}</div>
      </div>
      <div class="text-muted fs-6" v-if="recipients">Получатели: {{ recipients }}</div>
      <div class="text-muted fs-6" v-if="model?.address">Получатель: {{ model?.address }}</div>
      <div class="my-3" v-html="model.email_text" />
      <div class="text-muted fs-6" v-if="model.doc_template">
        Тип бланка: {{ model.doc_template?.name }}
      </div>
      <div class="text-muted fs-6" v-if="haveUploads">
        Загруженные файлы:

        <span v-for="f of model.official_reply?.uploads" :key="f.id">
          <a
            :href="`/api/v1.0/download/${f.secure_filename}`"
            :download="f.filename"
            class="fs-6 p-0 px-1 dload-link"
          >
            {{ f.filename }} <span v-if="f.autogenerated">(автогенерация)</span>
          </a>
        </span>

        <span v-for="f of model.uploads" :key="f.id">
          <a
            :href="`/api/v1.0/download/${f.secure_filename}`"
            :download="f.filename"
            class="fs-6 p-0 px-1 dload-link"
          >
            {{ f.filename }} <span v-if="f.autogenerated">(автогенерация)</span>
          </a>
        </span>
      </div>
    </div>
  </div>
</template>
